import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GAnimetion.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from "../../../src/CommonImports";

function GSingleHeader() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    return (
        <section className="section-box">
            <div className="box-head-single">
                <div className="container">
                    <h3>Senior UI / UX Designer</h3>
                    <ul className="breadcrumbs">
                        <li><a href="#">Home</a></li>
                        <li>Jobs listing</li>
                    </ul>
                </div>
            </div>
        </section>

    )

}
export default GSingleHeader;